<template>
  <div class="app-container">
    <div class="main-content">
      <!-- 面包屑导航 -->
      <div class="head">
        <span>当前位置：</span>
        <div class="breadcrumb">
          <span class="route" @click="gohome">首页</span>
          <span> > </span>
          <span>个人中心</span>
        </div>
      </div>

      <!-- 个人中心内容 -->
      <div class="profile-container">
        <!-- 左侧菜单 -->
        <div class="sidebar">
          <div class="user-card">
            <div class="avatar-wrapper">
              <img :src="userInfo.avatar || defaultAvatar" alt="头像" class="avatar" />
              <div class="user-info">
                <h3 class="username">{{ userInfo.name || userInfo.username || '用户' }}</h3>
                <!-- <span class="user-type">{{ userTypeText }}</span> -->
              </div>
            </div>
          </div>

          <div class="menu-nav">
            <div class="nav-item" :class="{ active: currentTab === 'profile' }" @click="currentTab = 'profile'">
              <i class="el-icon-user"></i>
              <span>个人资料</span>
            </div>
            <div class="nav-item" :class="{ active: currentTab === 'courses' }" @click="switchToCourses">
              <i class="el-icon-video-play"></i>
              <span>我的课程</span>
            </div>
            <div class="nav-item" :class="{ active: currentTab === 'public-courses' }" @click="switchToPublicCourses">
              <i class="el-icon-s-grid"></i>
              <span>公开课</span>
            </div>
          </div>
        </div>

        <!-- 右侧内容区 -->
        <div class="content-area">
          <!-- 个人资料 -->
          <div v-if="currentTab === 'profile'" class="profile-section">
            <div class="section-header">
              <h2>个人资料</h2>
              <p>管理您的个人信息和账户设置</p>
            </div>

            <div class="profile-content">
              <!-- 头像设置 -->
              <div class="avatar-section">
                <h3>头像设置</h3>
                <div class="avatar-upload">
                  <div class="avatar-preview">
                    <img :src="userInfo.avatar || defaultAvatar" alt="头像" />
                    <div class="upload-overlay" @click="$refs.avatarUpload.click()">
                      <i class="el-icon-camera"></i>
                      <span>更换头像</span>
                    </div>
                  </div>
                  <input ref="avatarUpload" type="file" accept="image/*" style="display: none"
                    @change="handleAvatarUpload" />
                  <div class="upload-tips">
                    <p>支持 JPG、PNG 格式，大小不超过 2MB</p>
                  </div>
                </div>
              </div>

              <!-- 基本信息 -->
              <div class="basic-info">
                <div class="section-header">
                  <h3>基本信息</h3>
                  <el-button type="primary" size="small" @click="showEditDialog = true">修改信息</el-button>
                </div>
                <div class="info-grid">
                  <div class="info-item">
                    <label>账号：</label>
                    <span class="value">{{ userInfo.username}}</span>
                  
                  </div>
                  <div class="info-item">
                    <label>姓名：</label>
                    <span class="value">{{ userInfo.name || '未设置' }}</span>
                  </div>
                  <div class="info-item">
                    <label>性别：</label>
                    <span class="value">{{ getSexText(userInfo.sex) }}</span>
                  </div>
                  <div class="info-item">
                    <label>电话：</label>
                    <span class="value">{{ userInfo.mobile || '未设置' }}</span>
                  </div>
                  <div class="info-item">
                    <label>邮箱：</label>
                    <span class="value">{{ userInfo.email || '未设置' }}</span>
                  </div>

                  <div class="info-item">
                    <label>最后登录：</label>
                    <span class="value">{{ formatDate(userInfo.loginDate) }}</span>
                  </div>
                </div>
              </div>

              <!-- 安全设置 -->
              <div class="security-section">
                <h3>安全设置</h3>
                <div class="security-item">
                  <div class="security-info">
                    <div class="title">登录密码</div>
                    <div class="desc">用于登录系统的密码，建议定期更换</div>
                  </div>
                  <el-button type="primary" @click="showPasswordDialog = true">修改密码</el-button>
                </div>

                <div class="security-item">
                  <div class="security-info">
                    <div class="title">退出登录</div>
                    <div class="desc">安全退出当前账户</div>
                  </div>
                  <el-button type="danger" @click="handleLogout">退出登录</el-button>
                </div>
              </div>
            </div>
          </div>

          <!-- 我的班级/课程 -->
          <div v-if="currentTab === 'courses'" class="courses-section">
            <!-- 班级列表视图 -->
            <div v-if="!selectedClass" class="class-list-view">
              <div class="section-header">
                <div class="header-left">
                  <h2>{{ '我的班级' }}</h2>
                  <!-- 学生查看所在的班级 -->
                </div>
                <div class="header-right">
                
                  <div class="search-container">
                    <!-- <el-input v-model="classSearchKeyword" placeholder="请输入班级名称搜索" prefix-icon="el-icon-search"
                      clearable @keyup.enter.native="searchClasses" @clear="resetClassSearch" class="search-input"
                      style="width: 250px;" />
                    <el-button type="primary" @click="searchClasses" style="margin-left: 10px;">搜索</el-button>
                    <el-button @click="resetClassSearch" style="margin-left: 5px;">重置</el-button> -->
                  </div>
                </div>
              </div>

              <div class="class-grid-container">
                <!-- 加载中状态 -->
                <div v-if="classLoading" class="loading-state">
                  <i class="el-icon-loading"></i>
                  <p>正在加载班级信息...</p>
                </div>

                <!-- 无班级内容 -->
                <div v-else-if="myClasses.length === 0" class="empty-state">
                  <i class="el-icon-school"></i>
                  <p v-if="classSearchKeyword">未找到匹配的班级</p>
                  <p v-else>暂未加入班级</p>
                </div>

                <!-- 班级列表滚动区域 -->
                <div v-else class="class-list-scroll">
                  <div class="class-grid">
                    <div v-for="classItem in myClasses" :key="classItem.id" class="class-card"
                      @click="selectClass(classItem)">
                      <div class="class-cover">
                        <img :src="classItem.courseImage || defaultCourseCover" alt="课程封面" @error="handleImageError($event)"
                          loading="lazy" />
                        <div class="class-overlay">
                          <i class="el-icon-right"></i>
                        </div>
                      </div>
                      <div class="class-info">
                        <h3 class="course-name">{{ classItem.courseInfo.courseName }}</h3>
                        <p class="class-name">{{ classItem.className }}</p>
                        <p class="teacher-name"><i class="el-icon-user"></i> {{ classItem.teacherName || '未知教师' }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 分页组件 -->
                <div v-if="classTotal > 0" class="class-pagination">
                  <el-pagination @current-change="handleClassPageChange" :current-page="currentClassPage"
                    :page-size="classPageSize" :total="classTotal" layout="prev, pager, next, total" small />
                </div>
              </div>
            </div>

            <!-- 课程列表视图 -->
            <div v-else class="course-list-view">
              <div class="section-header">
                <div class="back-section">
                  <el-button type="text" @click="backToClassList" class="back-btn">
                    <i class="el-icon-arrow-left"></i> 返回班级列表
                  </el-button>
                  <h2>{{ selectedClass.className }} - 课程列表</h2>
                </div>

              </div>

              <!-- 课程分类标签 -->
              <div class="course-tabs">
                <div class="tab-item" :class="{ active: currentCourseTab === 'live' }"
                  @click="currentCourseTab = 'live'">
                  <i class="el-icon-video-camera"></i>
                  <span>直播课程</span>
                  <span class="count">({{ liveCourseList.length }})</span>
                </div>
                <div class="tab-item" :class="{ active: currentCourseTab === 'recorded' }"
                  @click="currentCourseTab = 'recorded'">
                  <i class="el-icon-video-play"></i>
                  <span>录播课程</span>
                  <span class="count">({{ recordedCourseList.length }})</span>
                </div>
              </div>

              <div class="course-content-container">


                <!-- 课程列表 -->
                <div class="course-list-content">
                  <div v-if="currentCourseList.length === 0" class="empty-state">
                    <i :class="currentCourseTab === 'live' ? 'el-icon-video-camera' : 'el-icon-video-play'"></i>
                    <p>老师还没有发布{{ currentCourseTab === 'live' ? '直播' : '录播' }}课程</p>
                  </div>
                  <div v-else class="course-list">
                    <div v-for="course in currentCourseList" :key="course.id" class="course-item"
                      @click="playCourse(course)">
                      <div class="course-type-icon">
                        <i :class="course.type === 1 || course.type === 'live' ? 'el-icon-video-camera' : 'el-icon-video-play'"></i>
                      </div>
                      <div class="course-content">
                        <div class="course-header">
                          <h4 class="course-title">{{ course.name }}</h4>
                          <div class="course-type-badge"
                            :class="course.type === 1 || course.type === 'live' ? 'live' : 'recorded'">
                            {{ course.type === 1 || course.type === 'live' ? '直播' : '录播' }}
                          </div>
                        </div>
                        <!-- <div class="course-meta">
                          <span class="create-time">创建时间：{{ formatDate(course.createTime) }}</span>
                        </div> -->
                        <div v-if="isStudent && course.watched" class="progress-info">
                          <div class="progress-bar">
                            <div class="progress" :style="{ width: (course.progress || 0) + '%' }"></div>
                          </div>
                          <span class="progress-text">观看进度：{{ course.progress || 0 }}%</span>
                        </div>
                      </div>
                      <div class="course-action">
                        <i class="el-icon-caret-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 公开课 -->
          <div v-if="currentTab === 'public-courses'" class="public-courses-section">
            <div class="section-header">
              <div class="header-left">
                <h2>公开课</h2>
                <!-- 学生查看公开课 -->
                 <p>观看平台提供的所有公开课内容</p>
              </div>

            </div>

            <!-- 公开课分类标签 -->
            <div class="course-tabs">
              <div class="tab-item" :class="{ active: currentPublicCourseTab === 'live' }"
                @click="currentPublicCourseTab = 'live'">
                <i class="el-icon-video-camera"></i>
                <span>直播公开课</span>
                <span class="count">({{ publicLiveCourseList.length }})</span>
              </div>
              <div class="tab-item" :class="{ active: currentPublicCourseTab === 'recorded' }"
                @click="currentPublicCourseTab = 'recorded'">
                <i class="el-icon-video-play"></i>
                <span>录播公开课</span>
                <span class="count">({{ publicRecordedCourseList.length }})</span>
              </div>
            </div>

            <div class="public-course-content-container">
              <!-- 公开课列表 -->
              <div class="public-course-list-content">
                <div v-if="currentPublicCourseList.length === 0" class="empty-state">
                  <i :class="currentPublicCourseTab === 'live' ? 'el-icon-video-camera' : 'el-icon-video-play'"></i>
                  <p>暂无{{ currentPublicCourseTab === 'live' ? '直播' : '录播' }}公开课</p>
                </div>
                <div v-else class="public-course-list">
                  <div v-for="course in currentPublicCourseList" :key="course.id" class="public-course-item"
                    @click="playPublicCourse(course)">
                    <div class="course-type-icon">
                      <i :class="course.type === 1 || course.type === 'live' ? 'el-icon-video-camera' : 'el-icon-video-play'"></i>
                    </div>
                    <div class="course-content">
                      <div class="course-header">
                        <h4 class="course-title">{{ course.name }}</h4>
                        <div class="course-type-badge"
                          :class="course.type === 1 || course.type === 'live' ? 'live' : 'recorded'">
                          {{ course.type === 1 || course.type === 'live' ? '直播' : '录播' }}
                        </div>
                      </div>
                      <div class="course-meta">
                        <span class="create-time">创建时间：{{ formatDate(course.createTime) }}</span>
                      </div>
                      <div v-if="isStudent && course.watched" class="progress-info">
                        <div class="progress-bar">
                          <div class="progress" :style="{ width: (course.progress || 0) + '%' }"></div>
                        </div>
                        <span class="progress-text">观看进度：{{ course.progress || 0 }}%</span>
                      </div>
                    </div>
                    <div class="course-action">
                      <i class="el-icon-caret-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 修改密码对话框 -->
    <el-dialog title="修改密码" v-model="showPasswordDialog" width="450px" @close="resetPasswordForm">
      <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-width="80px">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入当前密码" show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码" show-password />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showPasswordDialog = false">取消</el-button>
        <el-button type="primary" :loading="passwordLoading" @click="handleChangePassword">
          确定修改
        </el-button>
      </div>
    </el-dialog>





    <!-- 编辑个人信息对话框 -->
    <el-dialog title="编辑个人信息" v-model="showEditDialog" width="500px" @close="resetEditForm">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="80px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="editForm.name" maxlength="30" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="editForm.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="电话" prop="mobile">
          <el-input v-model="editForm.mobile" maxlength="20" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="editForm.email" maxlength="50" placeholder="请输入邮箱" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditDialog = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click="handleSaveEdit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getClassVideos, getMyClasses, getUserProfile, updateUserProfile, logout, updateUserPassword, updateUserAvatar, getPublicCourses } from "@/api/index.js";

// 官网只支持学生登录，不再需要用户类型判断工具函数

export default {
  name: "Profile",
  components: {},
  data() {
    return {
      currentTab: 'profile',
      courseTab: 'live',
      userInfo: {},
      profileLoading: false,
      profileForm: {
        name: '',
        sex: 0,
        mobile: '',
        email: ''
      },
      profileRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^\d{6,20}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ]
      },
      showPasswordDialog: false,
      passwordLoading: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度为 6-20 位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ]
      },
      liveCourses: [], // 直播课程
      replayCourses: [], // 回放课程
      myClasses: [], // 我的班级
      selectedClass: null, // 当前选中的班级
      selectedClassId: null, // 当前选中班级ID
      currentClassVideos: [], // 当前班级的视频列表
      coursesLoaded: false, // 是否已加载课程数据
      currentCourseTab: 'live', // 当前课程标签 live/recorded

      defaultAvatar: '',
      defaultCourseCover: '',
      // 班级搜索和分页相关
      classSearchKeyword: '', // 班级搜索关键词
      currentClassPage: 1, // 当前页码
      classPageSize: 12, // 每页显示数量
      classTotal: 0, // 班级总数
      classLoading: false, // 班级加载状态
      // 公开课相关
      currentPublicCourseTab: 'live', // 当前公开课标签 live/recorded
      publicCourseList: [], // 公开课列表
      publicCoursesLoaded: false, // 公开课是否已加载

      // 编辑个人信息相关
      showEditDialog: false,
      editLoading: false,
      editForm: {
        name: '',
        sex: 0,
        mobile: '',
        email: ''
      },
      editRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^\d{6,20}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    // 官网只支持学生登录，简化用户类型判断
    isTeacher() {
      return false; // 官网不支持教师登录
    },
    isStudent() {
      return true; // 官网只支持学生登录
    },
    userTypeText() {
      return '学生'; // 固定为学生
    },
    // 当前班级的直播课程列表
    liveCourseList() {
      if (!this.currentClassVideos || this.currentClassVideos.length === 0) return [];
      return this.sortCourseList(
        this.currentClassVideos.filter(video => video.type === 'live' || video.type === 1)
      );
    },
    // 当前班级的录播课程列表
    recordedCourseList() {
      if (!this.currentClassVideos || this.currentClassVideos.length === 0) return [];
      return this.sortCourseList(
        this.currentClassVideos.filter(video => video.type === 'recorded' || video.type === 2)
      );
    },
    // 当前选中的课程列表
    currentCourseList() {
      return this.currentCourseTab === 'live' ? this.liveCourseList : this.recordedCourseList;
    },
    // 公开课的直播课程列表
    publicLiveCourseList() {
      if (!this.publicCourseList || this.publicCourseList.length === 0) return [];
      return this.sortCourseList(
        this.publicCourseList.filter(course => course.type === 'live' || course.type === 1)
      );
    },
    // 公开课的录播课程列表
    publicRecordedCourseList() {
      if (!this.publicCourseList || this.publicCourseList.length === 0) return [];
      return this.sortCourseList(
        this.publicCourseList.filter(course => course.type === 'recorded' || course.type === 2)
      );
    },
    // 当前选中的公开课列表
    currentPublicCourseList() {
      return this.currentPublicCourseTab === 'live' ? this.publicLiveCourseList : this.publicRecordedCourseList;
    }
  },
  created() {


    // 从Vuex获取用户信息，如果没有则请求
    const storeUserInfo = this.$store.getters.userInfo;

    if (storeUserInfo && Object.keys(storeUserInfo).length > 0 && storeUserInfo.id) {

      this.userInfo = storeUserInfo;
      this.profileForm = {
        name: this.userInfo.name || '',
        sex: this.userInfo.sex || 0,
        mobile: this.userInfo.mobile || '',
        email: this.userInfo.email || ''
      };
      this.editForm = {
        name: this.userInfo.name || '',
        sex: this.userInfo.sex || 0,
        mobile: this.userInfo.mobile || '',
        email: this.userInfo.email || ''
      };
    } else {

      this.getUserInfo();
    }
    // 移除自动调用getMyClasses()，改为按需调用
  },
  methods: {
    getCourseOrderValue(course) {
      if (!course || typeof course !== 'object') return null;

      const orderFields = [
        'sort',
        'sortNum',
        'sortNo',
        'sortOrder',
        'order',
        'orderNum',
        'serial',
        'serialNo',
        'sequence',
        'sequenceNum',
        'courseNo',
        'periodNo',
        'chapterNo',
        'lessonNo',
        'number',
        'num',
        'index'
      ];

      for (const field of orderFields) {
        const value = Number(course[field]);
        if (Number.isFinite(value) && value > 0) {
          return value;
        }
      }

      const courseName = String(course.name || course.title || '').trim();
      if (!courseName) return null;

      const namedMatch = courseName.match(/第\s*(\d+)\s*[课讲节章期]/);
      if (namedMatch) {
        return Number(namedMatch[1]);
      }

      const numericMatch = courseName.match(/(\d+)/);
      return numericMatch ? Number(numericMatch[1]) : null;
    },
    getCourseCreateTimeValue(course) {
      const timestamp = new Date(course && course.createTime ? course.createTime : 0).getTime();
      return Number.isFinite(timestamp) ? timestamp : 0;
    },
    sortCourseList(courseList) {
      if (!Array.isArray(courseList) || courseList.length === 0) return [];

      return [...courseList].sort((a, b) => {
        const aOrder = this.getCourseOrderValue(a);
        const bOrder = this.getCourseOrderValue(b);
        const aHasOrder = aOrder !== null;
        const bHasOrder = bOrder !== null;

        // 有明确序号时优先按序号升序排列
        if (aHasOrder && bHasOrder && aOrder !== bOrder) {
          return aOrder - bOrder;
        }

        if (aHasOrder !== bHasOrder) {
          return aHasOrder ? -1 : 1;
        }

        // 无序号或序号相同时，按创建时间倒序排列
        return this.getCourseCreateTimeValue(b) - this.getCourseCreateTimeValue(a);
      });
    },
    // 获取用户信息
    getUserInfo() {

      getUserProfile().then((res) => {

        if (res.data) {
          this.userInfo = res.data;
          this.profileForm = {
            name: res.data.name || '',
            sex: res.data.sex || 0,
            mobile: res.data.mobile || '',
            email: res.data.email || ''
          };
          this.editForm = {
            name: res.data.name || '',
            sex: res.data.sex || 0,
            mobile: res.data.mobile || '',
            email: res.data.email || ''
          };
          // 更新Vuex中的用户信息
          this.$store.dispatch('updateUserInfo', res.data);
        }
      }).catch(error => {

        this.$message.error('获取用户信息失败');
      });
    },

    // 切换到我的课程标签
    switchToCourses() {
      this.currentTab = 'courses';
      // 如果课程数据还没有加载，则加载数据
      if (!this.coursesLoaded) {
        this.getMyClasses();
      }
    },

    // 切换到公开课标签
    switchToPublicCourses() {
      this.currentTab = 'public-courses';
      // 如果公开课数据还没有加载，则加载数据
      if (!this.publicCoursesLoaded) {
        this.getPublicCourses();
      }
    },

    // 获取我的班级（分页查询）
    async getMyClasses(page = 1) {
      try {
        this.classLoading = true;

        // 获取用户类型（GW前端约定：1=教师，2=学生）
        const userType = this.$store.getters.userType || GW_USER_TYPE.STUDENT;

        const params = {
          userType: userType,
          pageNo: page,
          pageSize: this.classPageSize,
          className: this.classSearchKeyword || undefined,
          courseName: undefined // 可以后续添加课程名称搜索
        };

        const classesRes = await getMyClasses(params);

        if (classesRes.code !== 0 || !classesRes.data) {
          this.myClasses = [];
          this.classTotal = 0;
          this.coursesLoaded = true;
          return;
        }

        const pageResult = classesRes.data;
        const classes = pageResult.list || [];
        this.classTotal = pageResult.total || 0;

        // 只获取班级信息，不获取视频（视频在点击班级时获取）
        this.myClasses = classes.map(classItem => ({
          id: classItem.id,
          className: classItem.name,
          courseInfo: {
            courseName: classItem.courseName
          },
          courseImage: classItem.courseImage, // 课程封面图片
          teacherName: classItem.teacherName // 教师名称
        }));

        this.coursesLoaded = true;

      } catch (error) {
        this.$message.error('获取课程信息失败，请稍后重试');
        this.myClasses = [];
        this.classTotal = 0;
        this.coursesLoaded = false;
      } finally {
        this.classLoading = false;
      }
    },

    // 处理班级分页变化
    handleClassPageChange(page) {
      this.currentClassPage = page;
      this.getMyClasses(page);
    },

    // 搜索班级
    searchClasses() {
      this.currentClassPage = 1;
      this.getMyClasses(1);
    },

    // 重置搜索
    resetClassSearch() {
      this.classSearchKeyword = '';
      this.currentClassPage = 1;
      this.getMyClasses(1);
    },

    // 性别文本
    getSexText(sex) {
      switch (sex) {
        case 1: return '男';
        case 2: return '女';
        default: return '未设置';
      }
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '未知';
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-CN') + ' ' + date.toLocaleTimeString('zh-CN', { hour12: false });
    },

    // 头像上传
    handleAvatarUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 验证文件类型
      if (!file.type.startsWith('image/')) {
        this.$message.error('请选择图片文件');
        return;
      }

      // 验证文件大小（2MB）
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error('图片大小不能超过 2MB');
        return;
      }

      // 显示上传中提示
      const loading = this.$loading({
        lock: true,
        text: '头像上传中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 调用头像更新API
      updateUserAvatar(file).then((res) => {
        if (res.code === 0) {
          // 更新本地头像显示
          this.userInfo.avatar = res.data;
          // 更新Vuex中的用户信息
          this.$store.dispatch('updateUserInfo', { avatar: res.data });
          this.$message.success('头像更新成功');
        } else {
          this.$message.error(res.msg || '头像更新失败');
        }
      }).catch((error) => {
        console.error('头像上传失败:', error);
        this.$message.error('头像上传失败，请稍后重试');
      }).finally(() => {
        loading.close();
        // 清空文件输入框
        event.target.value = '';
      });
    },

    // 验证确认密码
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    },

    // 修改密码
    handleChangePassword() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          this.passwordLoading = true;

          // 调用修改密码接口
          const requestData = {
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword
          };

          updateUserPassword(requestData).then((res) => {
            if (res.code === 0) {
              this.$message.success('密码修改成功');
              this.showPasswordDialog = false;
              this.resetPasswordForm();
            } else {
              this.$message.error(res.msg || '密码修改失败');
            }
          }).catch((error) => {
            if (error.response && error.response.data && error.response.data.msg) {
              this.$message.error(error.response.data.msg);
            } else {
              this.$message.error('密码修改失败，请检查旧密码是否正确');
            }
          }).finally(() => {
            this.passwordLoading = false;
          });
        }
      });
    },

    // 重置密码表单
    resetPasswordForm() {
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.resetFields();
      }
    },

    // 保存基本信息
    handleSaveProfile() {
      if (!this.$refs.profileForm) return;
      this.$refs.profileForm.validate((valid) => {
        if (!valid) return;
        this.profileLoading = true;
        const payload = {
          name: this.profileForm.name,
          sex: this.profileForm.sex,
          mobile: this.profileForm.mobile,
          email: this.profileForm.email
        };
        updateUserProfile(payload)
          .then((res) => {
            if (res.code === 0) {
              this.$message.success('保存成功');
              this.userInfo = { ...this.userInfo, ...payload };
              this.$store.dispatch('updateUserInfo', this.userInfo);
            } else {
              this.$message.error(res.msg || '保存失败');
            }
          })
          .catch(() => {
            this.$message.error('保存失败，请稍后重试');
          })
          .finally(() => {
            this.profileLoading = false;
          });
      });
    },

    // 重置基本信息表单
    resetProfileForm() {
      this.profileForm = {
        name: this.userInfo.name || '',
        sex: this.userInfo.sex || 0,
        mobile: this.userInfo.mobile || '',
        email: this.userInfo.email || ''
      };
      this.$nextTick(() => {
        if (this.$refs.profileForm) this.$refs.profileForm.clearValidate();
      });
    },

    // 处理编辑对话框保存
    handleSaveEdit() {
      if (!this.$refs.editForm) return;
      this.$refs.editForm.validate((valid) => {
        if (!valid) return;
        this.editLoading = true;
        const payload = {
          name: this.editForm.name,
          sex: this.editForm.sex,
          mobile: this.editForm.mobile,
          email: this.editForm.email
        };
        updateUserProfile(payload)
          .then((res) => {
            if (res.code === 0) {
              this.$message.success('保存成功');
              this.userInfo = { ...this.userInfo, ...payload };
              this.$store.dispatch('updateUserInfo', this.userInfo);
              this.showEditDialog = false;
            } else {
              this.$message.error(res.msg || '保存失败');
            }
          })
          .catch(() => {
            this.$message.error('保存失败，请稍后重试');
          })
          .finally(() => {
            this.editLoading = false;
          });
      });
    },

    // 重置编辑表单
    resetEditForm() {
      this.editForm = {
        name: this.userInfo.name || '',
        sex: this.userInfo.sex || 0,
        mobile: this.userInfo.mobile || '',
        email: this.userInfo.email || ''
      };
      this.$nextTick(() => {
        if (this.$refs.editForm) this.$refs.editForm.clearValidate();
      });
    },

    // 选择班级
    async selectClass(classItem) {
      this.selectedClass = classItem;
      this.selectedClassId = classItem.id;
      // 默认选择第一个标签
      this.currentCourseTab = 'live';

      // 获取该班级的视频列表
      await this.refreshClassVideos();
    },

    // 刷新班级视频列表
    async refreshClassVideos() {
      if (!this.selectedClassId) {
        return;
      }

      try {
        const videosRes = await getClassVideos([this.selectedClassId]);

        if (videosRes.code === 0 && videosRes.data && videosRes.data.length > 0) {
          // API返回的是ClassVideoRespVO数组，需要提取第一个班级的videos
          const classVideoData = videosRes.data[0];
          this.currentClassVideos = classVideoData.videos || [];
          // 更新班级课程数量
          if (this.selectedClass) {
            this.selectedClass.courseCount = this.currentClassVideos.length;
          }
        } else {
          this.currentClassVideos = [];
        }
      } catch (error) {
        this.currentClassVideos = [];
        this.$message.error('获取班级视频失败');
      }
    },











    // 播放课程
    playCourse(course) {
      // 跳转到播放器页面，只传递必要的参数
      const playerUrl = this.$router.resolve({
        path: '/player',
        query: {
          videoId: course.id,
          classId: this.selectedClassId,
          videotype: course.type || 2
        }
      }).href;

      // 在新窗口打开播放器
      window.open(playerUrl, '_blank');
    },

    // 退出登录
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        logout().then(() => {
          // 使用Vuex清除登录状态
          this.$store.dispatch('logout');

          this.$message.success('已退出登录');
          this.gohome();
        }).catch(error => {
          // 即使接口失败，也清除本地存储
          this.$store.dispatch('logout');
          this.$message.success('已退出登录');
          this.gohome();
        });
      });
    },

    // 回到首页
    gohome() {
      this.$store.commit("activeNavIndex", 0);
      this.$router.push({ path: "/home" }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
        }
      });
    },

    // 返回班级列表
    backToClassList() {
      this.selectedClass = null;
      this.selectedClassId = null;
    },

    // 选择班级
    async selectClass(classItem) {
      this.selectedClass = classItem;
      this.selectedClassId = classItem.id;
      // 默认选择第一个标签
      this.currentCourseTab = 'live';

      // 获取该班级的视频列表
      try {
        const videosRes = await getClassVideos([classItem.id]);

        if (videosRes.code === 0 && videosRes.data && videosRes.data.length > 0) {
          // 后端返回的是ClassVideoRespVO数组，每个对象包含classId和videos数组
          const classVideoData = videosRes.data[0]; // 获取第一个班级的视频数据
          this.currentClassVideos = classVideoData.videos || [];

          // 更新班级的课程数量
          this.selectedClass.courseCount = this.currentClassVideos.length;

        } else {
          this.currentClassVideos = [];
          this.selectedClass.courseCount = 0;
        }
      } catch (error) {
        this.currentClassVideos = [];
        this.selectedClass.courseCount = 0;
        this.$message.error('获取班级视频失败');
      }
    },

    // 处理班级分页变化
    handleClassPageChange(page) {
      this.currentClassPage = page;
      this.getMyClasses(page);
    },

    // 处理图片加载错误
    handleImageError(event) {
      event.target.src = this.defaultCourseCover;
    },

    // =============  公开课相关方法 =============

    // 获取公开课列表
    async getPublicCourses() {
      try {
        const params = {
          pageNo: 1,
          pageSize: 100 // 获取所有公开课
        };

        const response = await getPublicCourses(params);

        if (response.code === 0 && response.data) {
          this.publicCourseList = response.data.list || response.data || [];
          this.publicCoursesLoaded = true;
        } else {
          this.publicCourseList = [];
          this.publicCoursesLoaded = true;
        }
      } catch (error) {
        this.$message.error('获取公开课信息失败，请稍后重试');
        this.publicCourseList = [];
        this.publicCoursesLoaded = false;
      }
    },









    // 播放公开课
    playPublicCourse(course) {
      // 跳转到播放器页面，只传递必要的参数
      const playerUrl = this.$router.resolve({
        path: '/player',
        query: {
          videoId: course.id,
          videotype: course.type || 2,
          isPublicCourse: true // 标记为公开课
        }
      }).href;

      // 在新窗口打开播放器
      window.open(playerUrl, '_blank');
    },

  }
};
</script>

<style scoped lang="scss">
.app-container {
  background: #f5f7fa;
  min-height: 100vh;
  font-family: "Microsoft YaHei", sans-serif;

  .main-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;

    .head {
      padding: 20px 0;
      display: flex;
      align-items: center;
      color: #666;
      font-size: 14px;

      .breadcrumb {
        .route {
          color: #409eff;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .profile-container {
      display: flex;
      gap: 24px;
      margin-bottom: 40px;

      .sidebar {
        width: 280px;

        .user-card {
          background: #fff;
          border-radius: 12px;
          padding: 24px;
          margin-bottom: 16px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

          .avatar-wrapper {
            display: flex;
            align-items: center;

            .avatar {
              width: 60px;
              height: 60px;
              border-radius: 50%;
              object-fit: cover;
              margin-right: 16px;
            }

            .user-info {
              .username {
                margin: 0 0 8px 0;
                font-size: 18px;
                font-weight: 600;
                color: #2c3e50;
              }

              .user-type {
                color: #718096;
                font-size: 14px;
                background: #e2e8f0;
                padding: 4px 12px;
                border-radius: 16px;
                display: inline-block;
              }
            }
          }
        }

        .menu-nav {
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

          .nav-item {
            padding: 16px 20px;
            display: flex;
            align-items: center;
            cursor: pointer;
            transition: all 0.3s ease;
            border-bottom: 1px solid #f1f5f9;

            i {
              margin-right: 12px;
              font-size: 18px;
              color: #718096;
            }

            span {
              color: #4a5568;
              font-weight: 500;
            }

            &:hover {
              background: #f8fafc;
            }

            &.active {
              background: #e3f2fd;
              border-right: 3px solid #2196f3;

              i,
              span {
                color: #2196f3;
              }
            }

            &:last-child {
              border-bottom: none;
            }
          }
        }
      }

      .content-area {
        flex: 1;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

        .section-header {
          padding: 32px 32px 24px 32px;
          border-bottom: 1px solid #e2e8f0;

          h2 {
            margin: 0 0 8px 0;
            font-size: 24px;
            font-weight: 600;
            color: #2d3748;
          }

          p {
            margin: 0;
            color: #718096;
            font-size: 14px;
          }
        }

        .profile-content {
          padding: 32px;

          h3 {
            margin: 0 0 20px 0;
            font-size: 18px;
            font-weight: 600;
            color: #2d3748;
          }

          .avatar-section {
            margin-bottom: 40px;

            .avatar-upload {
              display: flex;
              align-items: flex-start;
              gap: 20px;

              .avatar-preview {
                position: relative;
                width: 100px;
                height: 100px;

                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                  object-fit: cover;
                }

                .upload-overlay {
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  background: rgba(0, 0, 0, 0.5);
                  border-radius: 50%;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  opacity: 0;
                  transition: opacity 0.3s ease;
                  cursor: pointer;
                  color: #fff;

                  i {
                    font-size: 20px;
                    margin-bottom: 4px;
                  }

                  span {
                    font-size: 12px;
                  }
                }

                &:hover .upload-overlay {
                  opacity: 1;
                }
              }

              .upload-tips {
                flex: 1;

                p {
                  margin: 0;
                  color: #718096;
                  font-size: 14px;
                  line-height: 1.5;
                }
              }
            }
          }

          .basic-info {
            margin-bottom: 40px;

            .section-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 20px;

              h3 {
                margin: 0;
                font-size: 18px;
                font-weight: 600;
                color: #2d3748;
              }
            }

            .info-grid {
              .info-item {
                display: flex;
                align-items: center;
                padding: 16px 0;
                border-bottom: 1px solid #f1f5f9;

                label {
                  width: 100px;
                  font-weight: 500;
                  color: #4a5568;
                }

                .value {
                  flex: 1;
                  color: #2d3748;
                }

                .status {
                  font-size: 12px;
                  padding: 4px 8px;
                  border-radius: 4px;
                  margin-left: 8px;

                  &.readonly {
                    background: #f1f5f9;
                    color: #718096;
                  }
                }

                &:last-child {
                  border-bottom: none;
                }
              }

              // 兼容旧的info-row样式
              .info-row {
                display: flex;
                align-items: center;
                padding: 16px 0;
                border-bottom: 1px solid #f1f5f9;

                label {
                  width: 100px;
                  font-weight: 500;
                  color: #4a5568;
                }

                .value {
                  flex: 1;
                  color: #2d3748;
                }

                .status {
                  font-size: 12px;
                  padding: 4px 8px;
                  border-radius: 4px;

                  &.readonly {
                    background: #f1f5f9;
                    color: #718096;
                  }
                }

                &:last-child {
                  border-bottom: none;
                }
              }
            }
          }

          .security-section {
            .security-item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 20px 0;
              border-bottom: 1px solid #f1f5f9;

              .security-info {
                .title {
                  font-weight: 500;
                  color: #2d3748;
                  margin-bottom: 4px;
                }

                .desc {
                  color: #718096;
                  font-size: 14px;
                }
              }

              &:last-child {
                border-bottom: none;
              }
            }
          }
        }

        .course-tabs {
          display: flex;
          border-bottom: 1px solid #e2e8f0;

          .tab-item {
            padding: 16px 24px;
            cursor: pointer;
            display: flex;
            align-items: center;
            transition: all 0.3s ease;
            position: relative;

            i {
              margin-right: 8px;
              font-size: 16px;
            }

            .count {
              margin-left: 8px;
              color: #718096;
              font-size: 14px;
            }

            &:hover {
              color: #2196f3;
            }

            &.active {
              color: #2196f3;

              &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 30px;
                height: 3px;
                background: #2196f3;
                border-radius: 3px 3px 0 0;
              }
            }
          }
        }

        .course-list {
          padding: 32px;
          background: linear-gradient(135deg, #f8fafc, #e2e8f0);
          border-radius: 12px;

          .empty-state {
            text-align: center;
            padding: 80px 0;
            color: #a0aec0;

            i {
              font-size: 64px;
              margin-bottom: 16px;
              display: block;
            }

            h3 {
              margin: 0 0 8px 0;
              font-size: 18px;
              color: #4a5568;
            }

            p {
              margin: 0;
              color: #718096;
            }
          }

          .course-item {
                  background: linear-gradient(135deg, #ffffff, #f8f9fa);
                  border: 1px solid #dee2e6;
                  border-radius: 12px;
                  padding: 12px 16px;
                  margin-bottom: 12px;
                  transition: all 0.3s ease;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  gap: 16px;
                  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

              &:hover {
                box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
                transform: translateY(-3px);
                border-color: #3498db;
              }

              .course-type-icon {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background: linear-gradient(135deg, #3498db, #2980b9);
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                box-shadow: 0 2px 6px rgba(52, 152, 219, 0.3);

                i {
                  font-size: 16px;
                  color: white;
                }
              }

              .course-content {
                flex: 1;
                min-width: 0;

                .course-header {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 8px;

                  .course-title {
                    font-size: 16px;
                    font-weight: 600;
                    color: #2c3e50;
                    margin: 0;
                    line-height: 1.3;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    flex: 1;
                  }

                  .course-type-badge {
                    padding: 4px 8px;
                    border-radius: 12px;
                    font-size: 12px;
                    font-weight: 500;
                    color: white;
                    flex-shrink: 0;

                    &.live {
                      background: linear-gradient(135deg, #ff6b6b, #ee5a24);
                    }

                    &.recorded {
                      background: linear-gradient(135deg, #4834d4, #686de0);
                    }
                  }
                }

                .course-meta {
                  margin-bottom: 8px;

                  .create-time {
                    font-size: 14px;
                    color: #6c757d;
                    font-weight: 500;
                  }
                }

                .progress-info {
                  display: flex;
                  align-items: center;
                  gap: 8px;

                  .progress-bar {
                    flex: 1;
                    height: 4px;
                    background: #ecf0f1;
                    border-radius: 2px;
                    overflow: hidden;
                    max-width: 200px;

                    .progress {
                      height: 100%;
                      background: linear-gradient(90deg, #3498db, #2980b9);
                      transition: width 0.3s ease;
                    }
                  }

                  .progress-text {
                    font-size: 13px;
                    color: #6c757d;
                    font-weight: 600;
                  }
                }
              }

              .course-action {
                color: #95a5a6;
                font-size: 18px;
                flex-shrink: 0;
                transition: color 0.3s ease;

                &:hover {
                  color: #3498db;
                }
              }
            }
        }

        // 公开课模块样式
        .public-courses-section {
          .section-header {
            margin-bottom: 24px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .header-left {
              flex: 1;

              h2 {
                margin: 0 0 8px 0;
                font-size: 24px;
                font-weight: 600;
                color: #2d3748;
              }

              p {
                margin: 0;
                color: #718096;
                font-size: 14px;
              }
            }

            .header-right {
              flex-shrink: 0;
              margin-left: 20px;
            }
          }

          .public-course-content-container {
            background: #fff;
            border-radius: 0 0 12px 12px;

            .public-course-list-content {
              padding: 20px;
              min-height: 400px;

              .empty-state {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 200px;
                color: #a0aec0;

                i {
                  font-size: 48px;
                  margin-bottom: 12px;
                  color: #cbd5e0;
                }

                p {
                  margin: 0;
                  font-size: 14px;
                }
              }

              .public-course-list {
                margin-top: 20px;
                background: linear-gradient(135deg, #f8f9fa, #e9ecef);
                border-radius: 12px;
                padding: 16px;

                .public-course-item {
                  background: linear-gradient(135deg, #ffffff, #f8f9fa);
                  border: 1px solid #dee2e6;
                  border-radius: 12px;
                  padding: 12px 16px;
                  margin-bottom: 12px;
                  transition: all 0.3s ease;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  gap: 16px;
                  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

                  &:hover {
                    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
                    transform: translateY(-3px);
                    border-color: #3498db;
                  }

                  .course-type-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #3498db, #2980b9);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    box-shadow: 0 2px 6px rgba(52, 152, 219, 0.3);

                    i {
                      font-size: 16px;
                      color: white;
                    }
                  }

                  .course-content {
                    flex: 1;
                    min-width: 0;

                    .course-header {
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      margin-bottom: 8px;

                      .course-title {
                        font-size: 16px;
                        font-weight: 600;
                        color: #2c3e50;
                        margin: 0;
                        line-height: 1.3;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: center;
                        flex: 1;
                      }

                      .course-type-badge {
                        padding: 4px 8px;
                        border-radius: 12px;
                        font-size: 12px;
                        font-weight: 500;
                        color: white;
                        flex-shrink: 0;

                        &.live {
                          background: linear-gradient(135deg, #ff6b6b, #ee5a24);
                        }

                        &.recorded {
                          background: linear-gradient(135deg, #4834d4, #686de0);
                        }
                      }
                    }

                    .course-meta {
                      margin-bottom: 8px;

                      .create-time {
                        font-size: 14px;
                        color: #6c757d;
                        font-weight: 500;
                      }
                    }

                    .progress-info {
                      display: flex;
                      align-items: center;
                      gap: 8px;

                      .progress-bar {
                        flex: 1;
                        height: 4px;
                        background: #ecf0f1;
                        border-radius: 2px;
                        overflow: hidden;
                        max-width: 200px;

                        .progress {
                          height: 100%;
                          background: linear-gradient(90deg, #3498db, #2980b9);
                          transition: width 0.3s ease;
                        }
                      }

                      .progress-text {
                        font-size: 13px;
                        color: #6c757d;
                        font-weight: 600;
                      }
                    }
                  }

                  .course-action {
                    color: #95a5a6;
                    font-size: 18px;
                    flex-shrink: 0;
                    transition: color 0.3s ease;

                    &:hover {
                      color: #3498db;
                    }
                  }
                }
              }
            }
          }
        }

        // 课程模块样式
        .courses-section {
          .section-header {
            margin-bottom: 24px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .header-left {
              flex: 1;

              h2 {
                margin: 0 0 8px 0;
                font-size: 24px;
                font-weight: 600;
                color: #2d3748;
              }

              p {
                margin: 0;
                color: #718096;
                font-size: 14px;
              }
            }

            .header-right {
              flex-shrink: 0;
              margin-left: 20px;

              .search-input {
                width: 300px;
              }
            }

            .back-section {
              display: flex;
              align-items: center;
              gap: 16px;

              .back-btn {
                color: #2196f3;
                font-size: 14px;
                padding: 0;

                &:hover {
                  color: #1976d2;
                }
              }
            }

            .header-actions {
              display: flex;
              gap: 12px;
            }
          }

          // 班级列表视图
          .class-list-view {

            .class-pagination {
              margin-top: 20px;
              text-align: center;
            }

            .class-grid-container {
              .class-list-scroll {
                max-height: 700px;
                overflow-y: auto;
                padding-right: 8px;

                &::-webkit-scrollbar {
                  width: 6px;
                }

                &::-webkit-scrollbar-track {
                  background: #f1f1f1;
                  border-radius: 3px;
                }

                &::-webkit-scrollbar-thumb {
                  background: #c1c1c1;
                  border-radius: 3px;

                  &:hover {
                    background: #a8a8a8;
                  }
                }
              }

              background: #fff;
              border-radius: 12px;
              padding: 32px;
              min-height: 800px;

              .loading-state,
              .empty-state {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 300px;

                i {
                  font-size: 48px;
                  margin-bottom: 16px;
                }

                p {
                  margin: 0;
                  font-size: 16px;
                  color: #718096;
                }
              }

              .loading-state {
                color: #2196f3;

                i {
                  animation: spin 1s linear infinite;
                }
              }

              .empty-state {
                color: #a0aec0;

                i {
                  color: #cbd5e0;
                }
              }

              .class-grid {
                display: flex;
                flex-direction: column;
                gap: 16px;

                .class-card {
                  background: #fff;
                  border: 1px solid #e2e8f0;
                  border-radius: 12px;
                  overflow: hidden;
                  cursor: pointer;
                  transition: all 0.3s ease;
                  display: flex;
                  align-items: center;
                  min-height: 100px;

                  @media (max-width: 768px) {
                    flex-direction: column;

                    .class-cover {
                      width: 100% !important;
                      height: 120px !important;
                    }
                  }

                  &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

                    .class-overlay {
                      opacity: 1;
                    }

                    .class-cover img {
                      transform: scale(1.05);
                    }
                  }

                  .class-cover {
                    position: relative;
                    width: 140px;
                    height: 90px;
                    flex-shrink: 0;
                    overflow: hidden;
                    border-radius: 8px;

                    img {
                      width: 100%;
                      height: 100%;
                      object-fit: cover;
                      transition: transform 0.3s ease;
                    }

                    .class-overlay {
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      width: 32px;
                      height: 32px;
                      background: rgba(33, 150, 243, 0.9);
                      border-radius: 50%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: white;
                      font-size: 14px;
                      opacity: 0;
                      transition: opacity 0.3s ease;
                    }
                  }

                  .class-info {
                    flex: 1;
                    padding: 16px 20px;

                    .course-name {
                      margin: 0 0 6px 0;
                      font-size: 16px;
                      font-weight: 600;
                      color: #2d3748;
                      line-height: 1.4;
                      display: -webkit-box;
                      -webkit-line-clamp: 1;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                    }

                    .class-name {
                      margin: 0 0 8px 0;
                      color: #718096;
                      font-size: 14px;
                      line-height: 1.4;
                      display: -webkit-box;
                      -webkit-line-clamp: 1;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                    }

                    .teacher-name {
                      margin: 0;
                      color: #a0aec0;
                      font-size: 12px;
                      line-height: 1.4;
                      display: flex;
                      align-items: center;
                      gap: 4px;

                      i {
                        font-size: 12px;
                      }
                    }
                  }
                }
              }
            }
          }

          // 课程列表视图
          .course-list-view {
            .section-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }

            .course-tabs {
              display: flex;
              border-bottom: 1px solid #e2e8f0;
              background: #f8fafc;
              border-radius: 12px 12px 0 0;
              margin-bottom: 0;

              .tab-item {
                flex: 1;
                padding: 16px 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                cursor: pointer;
                transition: all 0.3s ease;
                position: relative;

                i {
                  font-size: 16px;
                }

                span {
                  font-size: 14px;
                  font-weight: 500;
                }

                .count {
                  color: #718096;
                  font-size: 12px;
                }

                &:hover {
                  color: #2196f3;
                  background: #e3f2fd;
                }

                &.active {
                  color: #2196f3;
                  background: #fff;

                  &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 40px;
                    height: 3px;
                    background: #2196f3;
                    border-radius: 3px 3px 0 0;
                  }
                }
              }
            }

            .course-content-container {
              background: #fff;
              border-radius: 0 0 12px 12px;

              .course-actions-bar {
                padding: 16px 20px;
                border-bottom: 1px solid #f1f5f9;
              }

              .course-list-content {
                padding: 20px;
                min-height: 400px;

                .empty-state {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  height: 200px;
                  color: #a0aec0;

                  i {
                    font-size: 48px;
                    margin-bottom: 12px;
                    color: #cbd5e0;
                  }

                  p {
                    margin: 0;
                    font-size: 14px;
                  }
                }


              }
            }
          }
        }
      }
    }
  }
}

// 对话框样式
:deep(.el-dialog ){
  border-radius: 12px;

  .el-dialog__header {
    padding: 24px 24px 0 24px;

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 0 24px 24px 24px;
  }
}

// 班级详情对话框样式
.class-detail {
  .class-info-header {
    display: flex;
    gap: 20px;
    margin-bottom: 32px;
    padding-bottom: 24px;
    border-bottom: 1px solid #e2e8f0;

    .class-cover {
      width: 120px;
      height: 80px;
      border-radius: 8px;
      overflow: hidden;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .class-basic-info {
      flex: 1;

      h3 {
        margin: 0 0 8px 0;
        font-size: 20px;
        font-weight: 600;
        color: #2d3748;
      }

      .class-name {
        margin: 0 0 12px 0;
        color: #718096;
        font-size: 16px;
      }

      .class-stats {
        display: flex;
        gap: 20px;

        span {
          color: #718096;
          font-size: 14px;
          display: flex;
          align-items: center;

          i {
            margin-right: 6px;
            color: #2196f3;
          }
        }
      }
    }
  }

  .class-courses {
    .courses-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: #2d3748;
      }
    }



    .empty-courses {
      text-align: center;
      padding: 40px 0;
      color: #a0aec0;

      i {
        font-size: 48px;
        margin-bottom: 12px;
        display: block;
        color: #cbd5e0;
      }

      p {
        margin: 0;
        color: #718096;
        font-size: 14px;
      }
    }
  }
}

// 添加课程对话框样式
.cover-upload {
  .upload-area {
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    cursor: pointer;
    transition: border-color 0.3s ease;

    &:hover {
      border-color: #2196f3;
    }

    .cover-preview {
      position: relative;
      width: 200px;
      height: 120px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
      }

      .cover-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: white;
        opacity: 0;
        transition: opacity 0.3s ease;

        i {
          font-size: 20px;
          margin-bottom: 4px;
        }

        span {
          font-size: 12px;
        }
      }

      &:hover .cover-overlay {
        opacity: 1;
      }
    }

    .upload-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px 20px;
      color: #999;

      i {
        font-size: 32px;
        margin-bottom: 8px;
        color: #ccc;
      }

      p {
        margin: 0 0 4px 0;
        font-size: 14px;
      }

      .upload-tip {
        font-size: 12px;
        color: #bbb;
      }
    }
  }
}

/* 响应式样式 */
@media (max-width: 1200px) {
  .profile-container {
    flex-direction: column;

    .sidebar {
      width: 100%;

      .menu-nav {
        display: flex;
        border-radius: 12px;

        .nav-item {
          flex: 1;
          justify-content: center;
          padding: 12px 8px;
          border-bottom: none;
          border-right: 1px solid #f1f5f9;
          flex-direction: column;
          gap: 4px;

          i {
            margin-right: 0;
            font-size: 16px;
          }

          span {
            font-size: 13px;
          }

          &.active {
            border-right: 1px solid #f1f5f9;
            border-bottom: 3px solid #2196f3;
          }

          &:last-child {
            border-right: none;
          }
        }
      }
    }

    .content-area {
      width: 100%;

      .section-header {
        padding: 20px 16px 16px;

        h2 {
          font-size: 20px;
        }
      }

      .profile-content {
        padding: 16px;
      }
    }

    .courses-section .courses-layout {
      flex-direction: column;
      height: auto;

      .class-sidebar {
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }
}

@media (max-width: 600px) {
  .app-container .main-content {
    padding: 0 12px;
  }

  .profile-container {
    gap: 12px;
    margin-bottom: 24px;

    .sidebar .user-card {
      padding: 16px;

      .avatar-wrapper .avatar {
        width: 48px;
        height: 48px;
      }
    }

    .sidebar .menu-nav .nav-item {
      padding: 10px 4px;

      span {
        font-size: 12px;
      }
    }

    .content-area .section-header {
      padding: 16px 12px 12px;

      h2 {
        font-size: 18px;
      }
    }

    .content-area .profile-content {
      padding: 12px;
    }

    .courses-section .class-card {
      flex-direction: column;

      .class-cover {
        width: 100% !important;
        height: 140px !important;
      }
    }
  }
}

/* 旋转动画 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
